// import { showAlert, hideAlert } from './alert';
import { apiClient } from '../../utils';
import { uploadMedia, handleError } from '../';

export const sortCampaign = async ({ campaigns, site, positionType }) => {
  try {
    const data = { campaigns, site, positionType };
    const response = await apiClient.post('/merchant/campaign/sort', { data });
    return response.result.sort;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
